import { Box, Flex, Image, Stack, Text } from "@chakra-ui/core";
import React from "react";
import { Link } from "react-router-dom";
import { demoProfile, recommendedJobs } from "../../../../Data/Jobs/index";
import facebook from "../../../../static/assets/icons/facebook.png";
import linkedIn from "../../../../static/assets/icons/LI-In-Bug.png";
import whatsapp from "../../../../static/assets/icons/whatsapp.png";
import mail from "../../../../static/assets/icons/mail.png";
import "./style.scss";

const LinkIconFetch = {
  mail: mail,
  linkedIn: linkedIn,
  facebook: facebook,
  whatsapp: whatsapp,
};

const ShareJobs = ({ links }) => (
  <Flex flexWrap="wrap">
    {links.map((each) => (
      <Link style={{ margin: "0 0.5em" }} to={each.value} key={each.value}>
        <Image src={LinkIconFetch[each.name]} size="24px" />
      </Link>
    ))}
  </Flex>
);

const EachJobCard = ({ job }) => {
  const {
    id,
    designation,
    company,
    fromNow,
    locationIcon,
    expIcon,
    salaryIcon,
    location,
    experience,
    salary,
    description,
    keywords,
  } = job;
  return (
    <Link to={`job/${id}`}>
      <Box
        p="10"
        mt="3"
        mb="10"
        mr="10"
        backgroundColor="#eeeeee"
        rounded="0.5em"
      >
        <Flex justify="space-between">
          <Stack>
            <Text fontSize="lg">{designation}</Text>
            <Text my="1" fontSize="md">
              {company}
            </Text>
          </Stack>
          <ShareJobs links={job.links} />
        </Flex>
        <Text my="1" fontSize="sm" color="grey">{`Posted ${fromNow}`}</Text>
        <Flex my="5">
          <Flex mr="5" align="center">
            <Image mr="2" src={locationIcon} />
            <Text fontSize="sm">{location}</Text>
          </Flex>
          <Flex mr="5" align="center">
            <Image mr="2" src={expIcon} />
            <Text fontSize="sm">{experience}</Text>
          </Flex>
          <Flex mr="5" align="center">
            <Image mr="2" src={salaryIcon} />
            <Text fontSize="sm">{`${salary[0]} - ${salary[1]}`}</Text>
          </Flex>
        </Flex>
        <Stack my="5">
          <Text fontSize="md">Description</Text>
          <Text
            fontSize="sm"
            className="job-description"
            textAlign="justify"
            color="grey"
          >
            {description}
          </Text>
        </Stack>
        <Stack my="5">
          <Text fontSize="md">Keywords</Text>
          <Text color="grey">{keywords.join(", ")}</Text>
        </Stack>
      </Box>
    </Link>
  );
};

function ShowJobs() {
  return (
    <Box>
      <Text fontSize="lg">{`${demoProfile[0].jobs.recommended.count} Recommended Job(s)`}</Text>
      {recommendedJobs.map((each) => (
        <EachJobCard
          key={each.designation.toLowerCase().split(" ").join("")}
          job={each}
        />
      ))}
    </Box>
  );
}

export default ShowJobs;
